import { render } from "./TestReportSettings.vue?vue&type=template&id=0a9f316e"
import script from "./TestReportSettings.vue?vue&type=script&lang=js"
export * from "./TestReportSettings.vue?vue&type=script&lang=js"

import "./TestReportSettings.vue?vue&type=style&index=0&id=0a9f316e&lang=css"
script.render = render

export default script